import { rgba } from 'polished'
import styled from 'styled-components'

import {
  StyledOrderDetailItem,
  StyledOrderDetailItemDivider
} from './OrderDetailItem.styles'
import { ClinTheme } from '../../../ClinTheme'
import { mediaQuery, mediaQueryDown } from '../../../utils/mediaQuery'
import { ClinText } from '../../../components/ClinText'
import { ClinPageContentFrame } from '../../../components/ClinPageContentFrame'
import { ClinButton } from '../../../components/ClinButton'

const MediumUpBreakpoint = ClinTheme.breakpoints[1]

export const StyledOrderDetail = styled.div({
  [`${StyledOrderDetailItem}:last-of-type`]: {
    [`${StyledOrderDetailItemDivider}`]: {
      display: 'none'
    }
  }
})

export const StyledCarrierImage = styled.img({
  width: '100%;',
  height: ClinTheme.space[5],
  objectFit: 'contain',
  objectPosition: 'left'
})

export const StyledOrderBar = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: ClinTheme.space[3],
  width: '100%',
  fontSize: ClinTheme.fontSizes[1],
  textTransform: 'uppercase',
  background: ClinTheme.colors.white,
  color: ClinTheme.colors.white,
  zIndex: 1,
  boxSizing: 'border-box',
  boxShadow: 'none',
  borderBottom: `1px solid ${ClinTheme.colors.midGrey}`
})

export const StyledIconHeading = styled.div({
  display: 'inline-flex',
  alignItems: 'center'
})

export const StyledOrderDetailShipping = styled.div({
  padding: `${ClinTheme.space[4]}px ${ClinTheme.space[5]}px`,
  background: rgba(ClinTheme.colors.primaryLightest, 0.15),
  borderBottom: `${ClinTheme.borderWidths[0]}px solid ${ClinTheme.colors.grey}`
})

export const ClinAddAllItems = styled.div({
  display: 'flex',
  justifyContent: 'flex-start',

  [mediaQuery(MediumUpBreakpoint)]: {
    justifyContent: 'flex-end'
  },

  [mediaQueryDown(MediumUpBreakpoint)]: {
    '.clin-button ': {
      width: '100%'
    }
  }
})

export const StyledProductDetailsSection = styled.div({
  backgroundColor: `${ClinTheme.colors.white}`,
  borderBottom: `1px solid ${ClinTheme.colors.grey}`,
  padding: `${ClinTheme.space[4]}px ${ClinTheme.space[3]}px`,
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'space-between',
  boxSizing: 'border-box'
})

export const StyledActions = styled.div({
  display: 'flex',
  gap: '16px',
  alignItems: 'center',
  justifyContent: 'end'
})

export const StyledClinPrimaryButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],
  paddingRight: ClinTheme.space[4],
  paddingLeft: ClinTheme.space[4],
  letterSpacing: 0
})

export const StyledClinSecondaryButton = styled(ClinButton)({
  color: ClinTheme.colors.primary,
  fontSize: ClinTheme.fontSizes[2],
  paddingRight: ClinTheme.space[4],
  paddingLeft: ClinTheme.space[4],
  letterSpacing: 0,

  '&:disabled': {
    color: ClinTheme.colors.darkGrey
  }
})

export const StyledLinkButton = styled(ClinButton)({
  fontSize: ClinTheme.fontSizes[2],
  color: ClinTheme.colors.primaryLight,
  height: '24px',
  textDecoration: 'none',
  letterSpacing: 0,

  '&:disabled': {
    color: ClinTheme.colors.darkGrey,
    cursor: 'not-allowed'
  }
})

export const OrderDetailHeaderContainer = styled.div({
  maxWidth: '100%',
  margin: '0 auto',
  backgroundColor: 'white'
})
export const StyledHeaderClinPageContentFrame = styled(ClinPageContentFrame)({
  padding: '24px 0px',
  marginBottom: '24px !important'
})
export const StyledOrderDetailHeaderContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'center'
})
export const StyledOrderDetailHeaderNavigation = styled.div({
  display: 'flex',
  flexDirection: 'column'
})
export const StyledOrderDetailHeaderContent = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center'
})
export const StyledOrderDetailHeaderTitle = styled(ClinText)({
  fontFamily: ClinTheme.fonts.groteskExtraBold,
  color: ClinTheme.colors.black,
  fontWeight: ClinTheme.fontWeights.bolder
})
export const StyledOrderDetailDeliveryDateContainer = styled.div({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  background: ClinTheme.colors.deliveryDateBackground,
  padding: ClinTheme.space[3],
  borderRadius: ClinTheme.radii[3],
  marginLeft: ClinTheme.space[3]
})
export const StyledOrderDetailDeliveryDateIconContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: ClinTheme.space[3],
  borderRadius: ClinTheme.radii[2]
})
export const StyledOrderDetailDeliveryDateContent = styled.div({
  display: 'flex',
  flexDirection: 'column'
})
export const StyledOrderDetailEstimatedDeliveryDateButton = styled(ClinButton)({
  border: 'none',
  color: ClinTheme.colors.primaryMid,
  fontSize: ClinTheme.fontSizes[2],
  height: '20px',
  fontWeight: ClinTheme.fontWeights.normal
})

export const StyledButtonLabel = styled.div({
  display: 'inline-block',
  margin: '0 8px'
})
